import React from 'react';
import { Stack, Typography } from '@mui/material';

export const EmptyConfigurationMessage = () => (
  <Stack>
    <Typography component="span" variant="subtitle2">
      This business process has not been configured yet
    </Typography>
    <Typography variant="body2">Please create a template to enable this flow</Typography>
  </Stack>
);
